const ProductCardSkeleton = () => {
  return (
    <div className='border-border flex flex-col gap-[12px] rounded-lg border p-[13px] shadow-sm'>
      <div className='h-[182px] rounded bg-gray-200'></div>
      <div>
        <div className='h-4 w-48 rounded bg-gray-200'></div>
        <div className='mt-1 h-4 w-32 rounded bg-gray-200'></div>
      </div>

      <div className='flex items-center gap-4'>
        <div className='h-5 w-20 rounded bg-gray-200'></div>
        <div className='h-5 w-12 rounded bg-gray-200'></div>
      </div>

      <div className='h-10 w-full rounded bg-gray-200'></div>
    </div>
  );
};

export default ProductCardSkeleton;
